import { Pagination, Stack, Tabs, Tab, Card, CardContent, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
// import PageTitle from "../../../components/PageTitle";
import { getDomainDetails, getSearchDomain, getAllResellerDetails, getCustomerCount, getResellerCount } from "../../../http/CentralizedDataHttp"; // Assuming getResellers exists
import DomainDetailModal from "../../../components/Centralized/DomainDetailModal";
import Input from "../../../components/Input";
import Div from "../../../components/Div";
import FormButton from "../../../components/FormButton";
import ResellerModal from "../../../components/Centralized/ResellerModal";
// import { Margin } from "@mui/icons-material";

const AlphabetPagination = () => {
    const [selectedLetter, setSelectedLetter] = useState('A');
    const [data, setData] = useState([]);
    const [resellers, setResellers] = useState([]);
    const [customerCount, setCustomerCount] = useState(0);
    const [activecustomerCount, setActiveCustomerCount] = useState(0);
    const [inactivecustomerCount, setInactiveCustomerCount] = useState(0);
    const [activeResellerCount, setActiveResellerCount] = useState(0);
    const [inactiveResellerCount, setInactiveResellerCount] = useState(0);
    const [resellerCount, setResellerCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [domainDetailModal, setDomainDetailModal] = useState(false);
    const [search, setSearch] = useState('');
    const [error, setError] = useState('Please select a letter to see data.');
    const [resellerModal, setResellerModal] = useState(false);
    const [tabValue, setTabValue] = useState(0); // 0 for Customers, 1 for Resellers
    const [alphabetCounts, setAlphabetCounts] = useState({});

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const currentItems = (tabValue === 0 ? data : resellers).slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil((tabValue === 0 ? data : resellers).length / itemsPerPage);

    const paginate = (event, value) => {
        setCurrentPage(value);
    };



    const alphabets = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

    const getDomainByLetter = async (letter) => {
        setLoading(true);
        const response = await getDomainDetails(letter);
        if (response) {
            setData(response.domains);
            setAlphabetCounts((prevCounts) => ({ ...prevCounts, [letter]: response.domains.length })); 
            setLoading(false);
        } else {
            setData([]);
            setAlphabetCounts((prevCounts) => ({ ...prevCounts, [letter]: 0 })); // Update count to 0 if no data
            setError('No data found for this letter.');
            setLoading(false);
        }
    };

    const getResellersData = async (letter) => { // Fetch reseller data
        setLoading(true);
        const response = await getAllResellerDetails(letter);
        if (response) {
            setResellers(response.customers); // Assuming the API returns an array of resellers
            setAlphabetCounts((prevCounts) => ({ ...prevCounts, [letter]: response.customers.length })); 
            setLoading(false);
        } else {
            setResellers([]);
            setAlphabetCounts((prevCounts) => ({ ...prevCounts, [letter]: 0 })); // Update count to 0 if no data
            setLoading(false);
            setError('No resellers found.');
        }
        setLoading(false);
    };

    const getCustomerCountData = async () => {
        const response = await getCustomerCount();
        if (response && response.count) {
            setCustomerCount(response.count?.count);
            setActiveCustomerCount(response.count?.active);
            setInactiveCustomerCount(response.count?.inactive);

        } else {
            setCustomerCount(0); // Handle potential errors gracefully
        }
    };

    const getResellerCountData = async () => {
        const response = await getResellerCount();
        if (response && response.count) {
            setResellerCount(response.count[0]?.reseller_count);
            setActiveResellerCount(response.active[0]?.active);
            setInactiveResellerCount(response.inactive[0]?.active);
        } else {
            setResellerCount(0); // Handle potential errors gracefully

        }
    };

    useEffect(() => {
        getDomainByLetter('A');
        getResellersData('A'); // Fetch resellers on component mount
        getCustomerCountData();
        getResellerCountData();
    }, []);

    const handleLetterClick = async (letter) => {
        setSelectedLetter(letter);
        await getDomainByLetter(letter);
        await getResellersData(letter);
    };

    const handleDomainClick = (domain_name, reseller_email) => {

        setDomainDetailModal({domain_name : domain_name, email: reseller_email});
    };

    const handleSearchDomain = async () => {
        
        const response = await getSearchDomain(search, tabValue === 0 ? 'customers' : 'resellers');
        if (response) {
            if (tabValue === 0) {
                setData(response.domains);
                setError('');
            }
            else{
                setResellers(response.domains);
                setError('');
            }

        } else {
            setData([]);
            setError('No Domain Found');
        }
    };

    const handleResellerClick = (username) => {
        const reseller_domain = username.split('@')[1];
        setResellerModal({domain:reseller_domain, reseller_email: username});
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setCurrentPage(1); // Reset page to 1 when switching tabs
    };


    return (
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
            {resellerModal ? <ResellerModal domain_name={resellerModal} show={true.toString()} open 
                handleClicked={setResellerModal} /> : null}
            {domainDetailModal ? <DomainDetailModal reseller={tabValue === 0 ? false : true}  
                domain_name={domainDetailModal.domain_name} email={domainDetailModal.email} show={true.toString()} open
                 handleClicked={setDomainDetailModal} /> : null}
            {/* <PageTitle title='Centralized Data' /> */}

            <Card variant="outlined" sx={{ mb: 2 }} style={{opacity : '0.9'}}>
                <CardContent>
                    <Typography variant="h6">Total Counts</Typography>
                    <Typography variant="body1"> <strong> Customers: </strong> {customerCount ?? 0} <p style={{marginLeft: '5px'}}> <strong> Active : </strong> {activecustomerCount ?? 0} <strong> Inactive : </strong> {inactivecustomerCount ?? 0} </p></Typography>
                    <Typography variant="body1"> <strong>Resellers: </strong> {resellerCount ?? 0} <p style={{marginLeft: '5px'}}> <strong> Active : </strong> {activeResellerCount ?? 0} <strong> Inactive : </strong> {inactiveResellerCount ?? 0} </p></Typography>
                </CardContent>
            </Card>

            <Div style={{marginBottom : '10px'}}>       
                <Tabs value={tabValue} onChange={handleTabChange}>
                <Tab label="Customers" style={{color : 'black'}}  />
                <Tab label="Resellers" style={{color : 'black'}} />
            </Tabs>
            </Div>

            <Div className='row'>
                <Div className='col-md-3' style={{opacity: '0.8'}}>
                    <Input value={search} type='text' name='search_domain' id='search_domain' 
                    style={{opacity: '0.8'}} onChange={(event) => setSearch(event.target.value)} />
                </Div>
                <Div className='col-md-1'>

                </Div>
                <Div className='col-md-2'>
                    <FormButton className="btn btn-primary submit-btn btn-block" onClick={handleSearchDomain}>Search</FormButton>
                </Div>
            </Div>

            {/* {tabValue === 0 && ( // Only show alphabets for Customers tab */}
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "20px", opacity: '0.8' }}>
                    {alphabets.map((letter) => (
                        <>
                        <span key={letter} style={{ position: 'relative' }}>
                        <button title={alphabetCounts[letter] || 0}
                            onMouseEnter={() => {}} //Added this line to make sure the tooltip can be shown correctly
                            onMouseLeave={() => {}} //Added this line to make sure the tooltip can be shown correctly   
                            key={letter}
                            onClick={() => handleLetterClick(letter)}
                            style={{
                                padding: "10px 15px",
                                cursor: "pointer",
                                backgroundColor: selectedLetter === letter ? "#007bff" : "#f8f9fa",
                                color: selectedLetter === letter ? "#fff" : "#000",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                
                            }}
                        >
                        
                            {letter}
                        </button>
                        <span style={{
                            position: 'absolute',
                            bottom: '100%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: 'black',
                            color: 'white',
                            padding: '5px 10px',
                            borderRadius: '5px',
                            fontSize: '12px',
                            display: 'none' // Initially hidden
                        }}
                            onMouseEnter={() => {
                                // Show tooltip on hover.
                                this.style.display = 'block';
                            }}
                            onMouseLeave={() => {
                                //Hide tooltip on mouseleave
                                this.style.display = 'none';
                            }}

                        >
                            {alphabetCounts[letter] || 0} {tabValue === 0 ? 'Customers' : 'Resellers'}
                        </span>
                    </span>
                        
                        </>
                    ))}
                </div>
            {/* )} */}


            <div>
                {loading ? (
                    <div>Loading data...</div>
                ) : currentItems.length > 0 ? (
                    <Div className="col-md-12 margin_top" style={{ opacity: '0.9' }} >
                    <table className="table" border="1">
                        <thead>
                            <tr>
                                <th>Domain</th>
                                <th>Company Name</th>
                               { tabValue === 0 ? <th>Customer Portal Username</th>: <th>Reseller Email</th>}
                                {/* {tabValue === 0 ? <th>Reseller</th> : null} Conditional rendering of Reseller column */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((item, index) => (
                                <tr key={index}>
                                   
                                    <td>
                                        <button className="btn btn-link" onClick={() => handleDomainClick(item.domain || item.domain_name, item.reseller_email)}> {/* Handle both domain and reseller_domain */}
                                            {item.domain || item.domain_name} </button>
                                    </td>
                                    <td>{item.company || item.company_name}</td>
                                    <td style={{ cursor: item.reseller_status === 'Y' ? 'pointer' : '' }} onClick={() => item.reseller_status === 'Y' ? handleResellerClick(item.username) : ''}>
                                        {item.username || item.reseller_email}
                                    </td>
                                    {/* {tabValue === 0 && <td>{item.reseller_status}</td>} */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </Div>
                ) : (
                    <div>
                             {error}
                        </div>
               
                )}
            </div>
            {currentItems.length > 0 && (
                <Stack spacing={2}>
                    <Pagination count={totalPages} color="primary" page={currentPage} onChange={paginate} />
                </Stack>
            )}
        </div>
    );
};

export default AlphabetPagination;
